import React from 'react'
import { PriceProps } from '../../lib/type'
import s from '@components/common/ProductTile/ProductTile.module.scss'
import cn from 'classnames'
import { formatPrice } from '@corratech/pylot-price'
import { useRouter } from 'next/router'

export const Price = ({ product }: PriceProps): JSX.Element | null => {
    const { locale } = useRouter()
    if (!product?.price_range?.minimum_price?.final_price?.value) {
        return null
    }
    const renderPrice = () => {
        return formatPrice(
            {
                value: product?.price_range?.minimum_price?.final_price?.value,
                currency:
                    product?.price_range?.minimum_price?.final_price?.currency
            },
            locale!
        )
    }
    return (
        <div
            className={cn(
                s['productitem-price'],
                'product-name productitem-price uppercase text-xs mt-4 leading-extra-4.4 font-semibold font-ookaParagraph tracking-extra-base cursor-pointer md:leading-5'
            )}
        >
            {renderPrice()}
        </div>
    )
}
export default Price
